<div [ngClass]="editClass" class="custom-checkbox">
  <input type="checkbox" id="myCheckbox" [checked]="checkboxStatus === 'true'" [ngClass]="boxClass"
    (change)="handleCheckboxChange($event)" />
    @if (checkBoxName) {
      <label class="myCheckbox editRoles__checkBox" [ngClass]='className'
        [ngStyle]="{'color': className === 'white' ? 'white' : 'black'}" [class.overflowLabel]="isOverflowLabel"
        data-bs-toggle="tooltip" [ngbTooltip]="isOverflowLabel ? checkBoxName : ''"
      [placement]="'right'">{{checkBoxName}}</label>
    }
  </div>